/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Form_Rule_Pointvalue1Inputs */



/**
* | output |
* | --- |
* | "The point value is" |
*
* @param {Alarms_Form_Rule_Pointvalue1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const alarms_form_rule_pointvalue1 = /** @type {((inputs?: Alarms_Form_Rule_Pointvalue1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Form_Rule_Pointvalue1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The point value is")
	return /** @type {LocalizedString} */ ("La valeur du point est")
});
export { alarms_form_rule_pointvalue1 as "alarms_form_rule_pointValue" }